import Css from "./Customer.module.css";
import {
    Row,
    Col,
    Form,
    Button,
    Tab,
    Table,
    InputGroup,
} from "react-bootstrap";
import { ButtonUploadFile } from "components/MyControl";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ApiConection from "api_ref/ApiConection";

export default function AccountChecking({
    data = undefined,
    disabled=false,
    stepPage = 1,
    dataPic,
    onChangeData = undefined,
    objPic,
    dataEdit,
    dataSubmit,
    onSubmit = undefined,
    loading = false,
    alert = ''    ,
    setAlert = undefined
}) {
    const api = new ApiConection();
    const navigate = useNavigate();


    const [selectData, setSelectData] = useState(undefined);

    const selectDataApi = async () => {
        const response = await api.getData(`api/master/audit-status`);
        if (response.status === true) {
            setSelectData(response.data);
        } else {
            return;
        }
    };

    const handleCancel = () => {
        switch (stepPage) {
            case 1:
            case 2:
            case 3:
                navigate(`/account/quontation-list`);
                break;
            case 4: navigate(`/account/complete-documents`);
                break;
        }
    }

    useEffect(() => {
        selectDataApi();
    }, []);

    const renderAccountCheck = () => {
        return (
            <div>
                {//data?.is_pay_now === false &&
                    (stepPage === 1 ||
                        stepPage === "1" ||
                        stepPage === 2 ||
                        stepPage === "2" ||
                        stepPage === 3 ||
                        stepPage === "3" ||
                        stepPage === 4 ||
                        stepPage === "4") &&
                    //(data?.payment_status_id === 1 || data?.payment_status_id === 3) &&
                    (
                        <Row className="mt-2">
                            <Col>
                                <Form.Check
                                    aria-label="option 1"
                                    label="ออกใบแจ้งหนี้แล้ว"
                                    className={`mb-2 ${Css.body2}`}
                                    id="is_issued_invoice"
                                    name="is_issued_invoice"
                                    disabled={disabled}
                                    onChange={(event) => onChangeData(event)}
                                    checked={dataSubmit?.is_issued_invoice}
                                    defaultChecked={dataSubmit?.is_issued_invoice}
                                />
                            </Col>

                            <Col>
                                <Form.Group className={`mb-2 ${Css.body2}`}>
                                    <Form.Label>เลขที่อ้างอิง/ บันทึกช่วยจำ</Form.Label>
                                    <Form.Control
                                        placeholder=""
                                        name={"issued_invoice_memo"}
                                        disabled={disabled}
                                        onChange={(event) => onChangeData(event)}
                                        defaultValue={dataSubmit?.issued_invoice_memo}
                                        value={dataSubmit?.issued_invoice_memo}
                                    />
                                </Form.Group>

                                <Form.Group className={`mb-2 ${Css.body2}`}>
                                    <Form.Label>แนบใบแจ้งหนี้</Form.Label>
                                    <div className={''}>
                                        <ButtonUploadFile
                                            name={"issued_invoice_file"}
                                            className={"btn btn-outline-secondary "}
                                            label={"คลิกเพื่อแนบเอกสาร"}
                                            readOnly={disabled}
                                            value={dataSubmit?.issued_invoice_file_id}
                                            defaultPreview={dataSubmit?.issued_invoice_file_image}
                                            onChange={(event) => onChangeData(event)}

                                        />
                                    </div>
                                </Form.Group>
                            </Col>
                        </Row>
                    )}

                {(data?.is_pay_now === true || data?.is_pay_now === false) &&
                    (stepPage === 2 ||
                        stepPage === "2" ||
                        stepPage === 3 ||
                        stepPage === "3" ||
                        stepPage === 4 ||
                        stepPage === "4") &&
                    //(data?.payment_status_id === 3) &&
                    (
                        <div>
                            <Row className="mt-3">
                                <Col>
                                    <Form.Check
                                        aria-label="option 1"
                                        label="ตรวจสอบการโอนเงินแล้ว"
                                        className={`mb-2 ${Css.body2}`}
                                        id='is_payment_verified'
                                        name="is_payment_verified"
                                        disabled={disabled}
                                        onChange={(event) => onChangeData(event)}
                                        checked={dataSubmit?.is_payment_verified}
                                        defaultChecked={dataSubmit?.is_payment_verified}
                                    />
                                </Col>

                                <Col>
                                    <Form.Group className={`mb-2 ${Css.body2}`}>
                                        <Form.Label>เลขที่อ้างอิง/ บันทึกช่วยจำ</Form.Label>
                                        <Form.Control
                                            placeholder=""
                                            name={"payment_verified_memo"}
                                            disabled={disabled}
                                            onChange={(event) => onChangeData(event)}
                                            value={dataSubmit?.payment_verified_memo}
                                            defaultValue={dataSubmit?.payment_verified_memo}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row className="mt-3">
                                <Col>
                                    <Form.Check
                                        aria-label="option 1"
                                        label="ออกใบเสร็จ/ใบกำกับภาษี"
                                        className={`mb-2 ${Css.body2}`}
                                        id='is_issued_receipt'
                                        name="is_issued_receipt"
                                        disabled={disabled}
                                        onChange={(event) => onChangeData(event)}
                                        checked={dataSubmit?.is_issued_receipt}
                                        defaultChecked={dataSubmit?.is_issued_receipt}
                                    />
                                </Col>

                                <Col>
                                    <Form.Group className={`mb-2 ${Css.body2}`}>
                                        <Form.Label>เลขที่อ้างอิง/ บันทึกช่วยจำ</Form.Label>
                                        <Form.Control
                                            placeholder=""
                                            name={"issued_receipt_memo"}
                                            disabled={disabled}
                                            onChange={(event) => onChangeData(event)}
                                            value={dataSubmit?.issued_receipt_memo}
                                            defaultValue={dataSubmit?.issued_receipt_memo}
                                        />
                                    </Form.Group>

                                    <Form.Group className={`mb-2 ${Css.body2}`}>
                                        <Form.Label>แนบใบเสร็จ/ใบกำกับภาษี</Form.Label>
                                        <div className={''}>
                                            <ButtonUploadFile
                                                name={"issued_receipt_file"}
                                                className={"btn btn-outline-secondary " + Css.bor1}
                                                label={"คลิกเพื่อแนบเอกสาร"}
                                                readOnly={disabled}
                                                value={dataSubmit?.issued_receipt_file_id}
                                                defaultPreview={dataSubmit?.issued_receipt_file_image}
                                                onChange={(event) => onChangeData(event)}

                                            />
                                        </div>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </div>
                    )}
                {(stepPage === 2 ||
                    stepPage === "2" ||
                    stepPage === 3 ||
                    stepPage === "3" ||
                    stepPage === 4 ||
                    stepPage === "4") &&
                    //(data?.is_with_holding_tax === true) &&
                    (
                        <Row className="mt-3">
                            <Col>
                                <Form.Check
                                    aria-label="option 1"
                                    label="ได้รับเอกสาร หักภาษี ณ ที่จ่าย"
                                    className={`mb-2 ${Css.body2}`}
                                    id='is_received_withholing_tax'
                                    name="is_received_withholing_tax"
                                    disabled={disabled}
                                    onChange={(event) => onChangeData(event)}
                                    checked={dataSubmit?.is_received_withholing_tax}
                                    defaultChecked={dataSubmit?.is_received_withholing_tax}
                                />
                            </Col>

                            <Col>
                                <Form.Group className={`mb-2 ${Css.body2}`}>
                                    <Form.Label>เลขที่อ้างอิง/ บันทึกช่วยจำ</Form.Label>
                                    <Form.Control
                                        placeholder=""
                                        name={"received_withholing_tax_memo"}
                                        onChange={(event) => onChangeData(event)}
                                        disabled={disabled}
                                        value={dataSubmit?.received_withholing_tax_memo}
                                        defaultValue={dataSubmit?.received_withholing_tax_memo}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    )}
            </div>
        );
    };

    return (
        <>
        {
            
            <>
             <div className={`${Css.Register_customer_layout2} mb-2`}>
                <Row>
                    <Col>
                        <h6>บัญชีตรวจสอบ</h6>
                    </Col>
                    <Col>
                        <label className="mt-3">สถานะ</label>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <label className={`mb-2 ${Css.body2}`}>{`( ลูกค้าประสงค์ ${data?.is_pay_now === false ? "ชำระภายหลัง" : "ชำระทันที"
                            } )`}</label>
                    </Col>
                    <Col>
                        <Form.Label>{data.audit_status_name}</Form.Label>
                    </Col>
                </Row>
                {renderAccountCheck()}
                <div className="mt-5"></div>
                {
                    alert !== '' &&
                    <div className="alert alert-danger" role="alert">
                        <div className="text-end">
                            <button type="button" className="btn-close" onClick={(event) => setAlert('')}></button>
                        </div>

                        {alert}
                    </div>
                }
                {
                    !disabled && 
                    <Row>
                        <Col className=" p-0">
                            <Button
                                type={"button"}
                                variant="outline-secondary"
                                className={`w-100`}
                                onClick={(_) => handleCancel()}>กลับหน้าหลัก</Button>
                        </Col>
                        <Col xs={(data.audit_status_id === 1 ? 8 : 6)}>
                            <Button type={"submit"} className={`btn btn-primary w-100`} name={'btnSave'} value={'btnSave'} onClick={onSubmit}>
                                {loading === true &&
                                    <div className="spinner-border spinner-border-sm" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>}
                                บันทึก
                            </Button>
                        </Col>
                    </Row>
                }
               
            </div>
            {
                !disabled && 
                <div className={`${Css.Register_customer_layout2} bg-purple-02`}>
                    <Row className="mb-3">
                        <Col>
                            <h6>เปลี่ยนสถานะ</h6>
                        </Col>
                        <Col>
                            <Form.Select
                                name="audit_status_id"
                                value={dataSubmit?.audit_status_id}
                                defaultValue={data?.audit_status_id}
                                onChange={(event) => {
                                    onChangeData(event);
                                }}
                            >
                                {/* map array api  */}
                                {
                                    selectData?.map((row, index) => {
                                        return < >
                                            {
                                                <option value={`${row.id}`} key={'_' + index} >{`${row.name}`}</option>
                                            }
                                        </>
                                    }
                                    )}
                            </Form.Select>
                        </Col>
                    </Row>
                    <div className="d-grid gap-2">
                        <Button type={'submit'} className="btn-purple" name={'btnChangeStatus'} value={'btnChangeStatus'} onClick={onSubmit} >
                            {loading === true &&
                                <div className="spinner-border spinner-border-sm" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>}
                            บันทึก/เปลี่ยนสถานะ และออกหน้าจอ</Button>
                    </div>
                </div>
            }

            </>
        }
        </>
    );
}